import { Modifier } from '../modifier';
import type { Damage } from '../damage.type';
import {
  ModifierPriority,
  ModifierTags,
  StatusEffect,
  type ModifierParams,
} from '../modifier.type';
import { StatusEffectRegistry } from '../status-effects';

export class Weakness extends Modifier {
  static readonly baseTitle = 'Weakness';
  static readonly baseText =
    'Decrease all damage dealt by the number of stacks multiplied by the number of die. Stable.';
  static readonly baseIcon = 'weakness';
  static readonly baseTags = [ModifierTags.Bane];
  static readonly basePriority = ModifierPriority.Early;

  // Instance properties that can change
  title = Weakness.baseTitle;
  text = Weakness.baseText;
  icon = Weakness.baseIcon;
  tags: Array<ModifierTags> = [...Weakness.baseTags];
  priority = Weakness.basePriority;

  update(stacks: number, params: ModifierParams) {
    super.update(stacks, params);
    this.delay = true;
  }

  startTurn() {
    const distracted = this.owner.statusEffects.find(
      (modifier) => modifier.type === StatusEffect.Distracted,
    );
    if (!distracted) {
      this.delay = false;
    }
  }

  endTurn() {
    if (!this.delay) {
      this.removeStacks(1);
    }
  }

  damageOut(damage: Damage) {
    damage.value -= this.stacks * Math.max(damage.dice.length, 1);
  }
}

// Register the status effect
StatusEffectRegistry.register(StatusEffect.Weakness, Weakness);
